import Logo from "../PublicComponents/Assetss/Logo.png";
import img1 from "../PublicComponents/Assetss/img1.jpg"
import img2 from "../PublicComponents/Assetss/img2.jpg"
import img3 from "../PublicComponents/Assetss/img3.jpg"
import img4 from "../PublicComponents/Assetss/img4.jpg"
import img5 from "../PublicComponents/Assetss/img5.jpg"
import img6 from "../PublicComponents/Assetss/img6.jpg"

import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import SecurityIcon from "@mui/icons-material/Security";

export const CONSTANTS_STRINGS = {
  header: {
    address: "401, Arcade Silver, 56 Dukan Palasia, Indore, 452001",
    phone: "0731-3137270",
    email: "info@devqsoft.com",
    twitter: "https://x.com/",
    instagram: "https://instagram.com",
    linkedin: "https://linkedin.com",
  },
  banner: {
    logo: Logo,
    img: img3,
    contact_button: "Get Your Consult!",
    title: "Empowering Your Financial Future",
    description:
      "Unlock your financial potential with personalized planning and expert advice tailored to your goals.",
    button_text: "View All Service",
  },
  menuicon: {
    title: "Finwice Construction",
    description:
      "Nam augue velit, fermentum sed erat non, efficitur interdum lectus. Donec hendrerit lorem a dui euismod tempus.",
    contactTitle: "Contact Us",
    address: "401, Arcade Silver, 56 Dukan Palasia, Indore, 452001",
    phone: "0731-3137270",
    email: "info@devqsoft.com",
  },
  about: {
    t1: "WE ARE FINWICE",
    t2: "At FinWice, we offer expert financial planning to help you reach your goals. Our team provides tailored strategies and solutions for your financial success and security.",
    about_button: "About Us",
    t3: "Years of Financial Planning Expertise",
    features: [
      {
        id: "expertise",
        title: "Expertise",
        description:
          "We bring years of industry experience to help you make informed financial decisions with confidence.",
      },
      {
        id: "innovation",
        title: "Innovation",
        description:
          "We leverage the latest financial technologies to create cutting-edge solutions tailored to your needs.",
      },
      {
        id: "commitment",
        title: "Commitment",
        description:
          "Our dedication to clients ensures personalized strategies for long-term financial growth.",
      },
    ],
  },
  services: [
    {
      icon: TrendingUpIcon,
      title: "Tailored Strategies",
      description:
        "Customized financial plans designed to meet your unique goals and financial situation.",
    },
    {
      icon: ShowChartIcon,
      title: "Investment Growth",
      description:
        "Expert strategies to enhance investment returns and drive consistent growth for you.",
    },
    {
      icon: RequestQuoteIcon,
      title: "Financial Security",
      description:
        "Comprehensive solutions to safeguard assets and ensure long-term financial stability.",
    },
    {
      icon: SecurityIcon,
      title: "Tax Savings",
      description:
        "Effective strategies to minimize tax liabilities and enhance financial returns and savings.",
    },
  ],
  SuccssesStorie: {
    t1: "OUR FEATURED PROJECT",
    t2: "Succsses Stories",
    t3: "Discover how we’ve helped clients achieve remarkable results.",
    SuccssesStories: [
      {
        src: img1,
        text: "Debt-Free in 12 Months",
        text1: "Ravi Kumar",
        text3:
          "With our financial planning tools, Ravi cleared ₹5L in credit card debt within a year.",
      },
      {
        src: img2,
        text: "Smart Investing, Big Returns",
        text1: "Anjali Mehra",
        text3:
          "Anjali grew her SIP portfolio by 40% in 2 years with expert mutual fund guidance.",
      },
      {
        src: img3,
        text: "From Zero to ₹50L",
        text1: "Startup Founder",
        text3:
          "Using our business finance tools, a client scaled their e-commerce startup to ₹50L in revenue.",
      },
      {
        src: img4,
        text: "Home Loan Approved Easily",
        text1: "Suresh Nair",
        text3:
          "With better credit management tips, Suresh secured a home loan at a low interest rate.",
      },
      {
        src: img5,
        text: "Retirement Plan Secured",
        text1: "Meena Joshi",
        text3:
          "Meena built a stable retirement corpus through SIPs and PPF with our financial roadmap.",
      },
      {
        src: img6,
        text: "Emergency Fund Success",
        text1: "Rahul Singh",
        text3:
          "Rahul saved 6 months of salary as an emergency fund after following our budget strategy.",
      },
    ],
  },
  faqs: {
    faq: "FAQS",
    t1: "Proven Results You Can See",
    t2: "Find answers to some of the most common questions about financial planning, from budgeting and investment strategies to retirement planning and managing debt.",
    button: "Schedule A Consultation",
    items: [
      {
        id: 1,
        question: "What financial services do you offer?",
        answer:
          "We provide comprehensive financial planning, investment management, retirement planning, tax optimization strategies, and wealth preservation services tailored to your unique goals.",
      },
      {
        id: 2,
        question: "How do you charge for your services?",
        answer:
          "Our fee structure varies based on services: either flat fees for specific plans, hourly consulting rates, or a percentage of assets under management for ongoing portfolio management.",
      },
      {
        id: 3,
        question: "What makes your financial advice different?",
        answer:
          "We combine data-driven strategies with personalized attention, focusing on long-term relationships rather than short-term gains. Our fiduciary approach ensures advice always benefits you.",
      },
      {
        id: 4,
        question: "How often will we review my financial plan?",
        answer:
          "We conduct quarterly performance reviews, annual comprehensive plan updates, and are available for ad-hoc consultations whenever your financial situation changes.",
      },
      {
        id: 5,
        question: "Do you work with clients internationally?",
        answer:
          "Yes, we serve clients globally with cross-border financial planning expertise, though certain services may be limited based on local regulations in your country.",
      },
      {
        id: 6,
        question: "What makes your financial advice different?",
        answer:
          "We combine data-driven strategies with personalized attention, focusing on long-term relationships rather than short-term gains. Our fiduciary approach ensures advice always benefits you.",
      },
    ],
  },
  footer: {
    description:
      "Welcome to your trusted financial partner! Explore personalized strategies and expert guidance to secure your financial future and achieve success.",
    address: "401, Arcade Silver, 56 Dukan Palasia, Indore, 452001",
    phone: "0731-3137270",
    email: "info@devqsoft.com",
    categories: [
      "Market Research",
      "Strategic Planning",
      "Change Management",
      "Operational Efficiency",
      "Retirement Planning",
    ],
    quickLinks: [
      "About Us",
      "Our Team",
      "Pricing",
      "Blog",
      "Case Studies",
      "Contact",
    ],
    subscribeTitle: "Subscribe for all the top news!",
    subscribePlaceholder: "Enter Your Email Address",
    subscribeText:
      "Sign up for updates on our latest news and events. No spam, just valuable insights!",
    copyrightText: "Copyright © 2025 finwice By",
    copyrightOwner: "devQsoft",
    policies: ["Terms of Service", "Privacy Policy", "Cookie Policy"],
  },
};
